<app-nav *ngIf="!specialPage"></app-nav>
<main [ngClass]="{'px-0 py-0 my-0 mx-0': specialPage, 'mt-5 pt-1': !specialPage}">
  <div [class.container-fluid]="!specialPage">
    <router-outlet></router-outlet>
  </div>
</main>
